// =============================================================================
// DeliveryHub.js — the Deliveries page (2026-10). The left rail's "Deliveries"
// button opens this page; what used to be its flyout items are tabs here:
// Route analysis, Activity and Payments. App.js still decides which panel is
// showing (its views "route_analysis", "delivery_activity", "payments"), so
// links straight to one of them (e.g. a pharmacy's route analysis) still work.
// =============================================================================
import React from "react";

export const DELIVERY_TABS = [
  { view: "route_analysis", label: "Route analysis", title: "Delivery driver routes and efficiency." },
  { view: "delivery_activity", label: "Activity", title: "Deliveries, mileage and time over a date range, by site and driver." },
  { view: "payments", label: "Payments", title: "Delivery payment plans by branch: who is covered, whose plan has expired, and who is still being delivered to on a lapsed plan." },
];
const LS_KEY = "deliveryTab";
// The tab the Deliveries button opens: the one last used in this browser.
export function lastDeliveryTab() {
  try { const v = localStorage.getItem(LS_KEY); if (DELIVERY_TABS.some((t) => t.view === v)) return v; } catch { /* storage unavailable */ }
  return DELIVERY_TABS[0].view;
}

export default function DeliveryHub({ tab, onTab, children }) {
  React.useEffect(() => { try { localStorage.setItem(LS_KEY, tab); } catch { /* storage unavailable */ } }, [tab]);
  return (
    <div>
      <div style={{ padding: "16px 20px 0" }}>
        <h1 style={{ margin: 0, fontSize: 22 }}>Deliveries</h1>
        <div role="tablist" aria-label="Deliveries" style={{ display: "flex", gap: 4, marginTop: 12, borderBottom: "2px solid #F0F0F0", flexWrap: "wrap" }}>
          {DELIVERY_TABS.map((t) => {
            const on = t.view === tab;
            return <button key={t.view} role="tab" aria-selected={on} title={t.title} onClick={() => !on && onTab(t.view)}
              style={{ border: "none", borderBottom: on ? "3px solid #0958D9" : "3px solid transparent", background: "none", padding: "8px 14px", marginBottom: -2,
                fontSize: 14, fontWeight: on ? 700 : 500, color: on ? "#0958D9" : "#434343", cursor: on ? "default" : "pointer" }}>{t.label}</button>;
          })}
        </div>
      </div>
      <div role="tabpanel">{children}</div>
    </div>
  );
}
